import React, { useContext } from 'react';
import Icon from '@msi/cobalt-react/icon';
import Button from '@msi/cobalt-react/button';
import { useNavigate } from 'react-router-dom';
import { BatchUploadContext } from '../BatchUpload/BatchUploadContext';
import './HomeHeader.css'

const HomeHeader = () => {
    const navigate = useNavigate();
    const { setShowBatchUpload } = useContext(BatchUploadContext);

    return (
        <>
            <div className='home_header'>
                <Icon name='ic_home' size={36} color='primary' />
                <div className='home_header_text'>
                    <p className='home_title'>API Hub</p>
                </div>
                <div className='home_header_actions'>
                    <Button text='Add API' className='addAPI' onClick={() => navigate("/add-record")} />
                    <Button
                        text="Batch Upload"
                        className='batchUpload'
                        buttonType='action'
                        onClick={() => setShowBatchUpload(true)}
                    />
                </div>
            </div>
        </>
    );
};

export default HomeHeader;